/* @flow */

import { makeIDLink } from './utils';

export default makeIDLink({ pathname: '/annotations' });



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/components/Links/AnnotationLink.js